"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsWrapper = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var ControlsWrapper = function (_a) {
    var onChangeMinus = _a.onChangeMinus, onChangePlus = _a.onChangePlus, disabledMinus = _a.disabledMinus, disabledPlus = _a.disabledPlus, children = _a.children, unused = __rest(_a, ["onChangeMinus", "onChangePlus", "disabledMinus", "disabledPlus", "children"]);
    return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)('br-flex') }, unused),
        react_1.default.createElement(__1.Button, { buttonType: "primary", size: "sm", disabled: disabledMinus, onClick: onChangeMinus, className: (0, classnames_1.default)('br-w-12') },
            react_1.default.createElement(__1.IconRemove, { style: { fontSize: '2em' } })),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('br-grow', 'br-mx-2') }, children),
        react_1.default.createElement(__1.Button, { buttonType: "primary", size: "sm", disabled: disabledPlus, onClick: onChangePlus, className: (0, classnames_1.default)('br-w-12') },
            react_1.default.createElement(__1.IconAdd, { style: { fontSize: '2em' } }))));
};
exports.ControlsWrapper = ControlsWrapper;
